import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
export function withSuspense(Component, fallback = null) {
    return function WithSuspense(props) {
        return (_jsx(Suspense, { fallback: typeof fallback === 'function' ? fallback(props) : fallback, children: _jsx(Component, { ...props }) }));
    };
}
//# sourceMappingURL=withSuspense.js.map